import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e5c109c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5e5c109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c109c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchProductCard: require('/vercel/path0/components/search/SearchProductCard.vue').default,SearchPageCard: require('/vercel/path0/components/search/SearchPageCard.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
